import React from 'react';
import { ADD_CASH, renderCTA, RESOLVE_VARIANCE } from '.';
import { CTA_SIZE, CTA_TYPE } from '../../../../data/constants';
const Header = (props: any) => {
  const {
    data,
    formValues,
    setFormValues,
    modalState,
    setModalState,
    toggleViewSettlement,
  } = props;

  const CTA_CONFIG = {
    addCash: {
      ctaSize: CTA_SIZE.medium,
      ctaText: '+ ADD CASH',
      ctaType: CTA_TYPE.primary_cta,
      onCtaClick: () => {
        setFormValues({ ...formValues, transactionType: 'Float' });
        setModalState({
          ...modalState,
          header: 'Add Cash',
          subText: 'Add balance to your cash drawer',
          show: true,
          type: ADD_CASH,
        });
      },
      customClass: 'h-10 w-[20%] p-0 sm:text-[13px] sm:w-[81px] text-[#397EF5]',
    },
    resolveVariance: {
      ctaSize: CTA_SIZE.medium,
      ctaText: 'RESOLVE VARIANCE',
      ctaType: CTA_TYPE.primary_cta,
      onCtaClick: () =>
        setModalState({
          ...modalState,
          header: 'Resolve Variance',
          type: RESOLVE_VARIANCE,
          subText: 'Please mention reason of variances below',
          show: true,
        }),
      customClass: 'h-10 w-[20%] sm:text-[13px] sm:w-[45%] p-0 text-[#397EF5]',
    },
  };

  return (
    <div className="flex py-24 pl-20 pr-[60px] sm:pt-2 sm:pb-2 sm:pl-5 sm:pr-16 justify-between items-center border-b-[1px] h-65 ">
      <span
        className="flex items-center"
        onClick={() => toggleViewSettlement('')}
      >
        <div className="rista-sprite ic-arrow-left"></div>
        <div className="text-black text-14 font-semibold ">Back</div>
      </span>
      <span className="sm:hidden">{renderStatusInfo(data)}</span>
      {data.status === 'Open' ? (
        renderCTA(CTA_CONFIG.addCash)
      ) : data.balanceStatus === 'Due' ? (
        renderCTA(CTA_CONFIG.resolveVariance)
      ) : (
        <span className="w-40"></span>
      )}
    </div>
  );
};

export function renderStatusInfo(data: any) {
  return (
    <div className="text-black text-18 font-semibold sm:py-12 sm:px-16 sm:justify-between w-full flex items-center">
      <span
        className={`text-13 mr-16 font-semibold py-6 px-12 rounded-[8px] uppercase ${
          data.status === 'Open'
            ? 'bg-[#397EF5]/5 text-[#397EF5]'
            : 'text-black/[0.48] bg-black/5'
        }`}
      >
        {data.status}
      </span>
      <div className="sm:ml-auto">
        Settlement #{data.settlementNumber} for{' '}
        {data?.userInfo?.userName?.firstName}
      </div>
    </div>
  );
}

export default Header;
